import { WebVTTThumbnail } from "./Webvtt.js";
import { ThumbnailPositionOnSeekbarHover } from "./ThumbnailGalleryCover.js"

export { Thumbnail }


/**
 * Define methods for the thumbnail preview in the Shaka Player when hovering over its seek bar
 * @memberof vef.ui.media
 * @author ckraemme <ckraemme@awi.de>
 * @private
 */
class Thumbnail {
    /**
     * Extend the functionality of the Shaka Player seek bar by showing thumbnail images for mouse hovering
     * @param {Object} targetElement - Shaka Player container element
     * @param {string} thumbnailPath - path to the webVTT thumbnail file
     * @param {Number} preloadThumbnailsNumber - number of thumbnails that should be preloaded
     * @param {boolean} preloadThumbnailsSparse - if true, load the thumbnails spread over the whole video, otherwise ascending from the beginning (for separated thumbnail images only)
     */
    constructor(targetElement, thumbnailPath, preloadThumbnailsNumber, preloadThumbnailsSparse) {

        this.shakaContainer = targetElement;
        const thumbnailObject = new WebVTTThumbnail(thumbnailPath);
        thumbnailObject.init(preloadThumbnailsNumber, preloadThumbnailsSparse);
        this.buildThumbnailBox_();
        this.computeThumbnailBoxStyle_();
        this.setThumbnailBoxStyle_();
        new ThumbnailPositionOnSeekbarHover(this.seekbar, this.thumbnailCanvasElement, this.thumbnailBoxWidth, this.thumbnailBoxHeight, thumbnailPath, this.timestampTextElement, "");

        this.seekbar.addEventListener('pointermove', (event) => {
            this.thumbnailContainerElement.style.display = "block";
            this.computeThumbnailBoxStyle_();
            this.setThumbnailBoxStyle_();
            const mouseEventX = event.offsetX;
            const seekbarWidth = this.seekbar.getBoundingClientRect().width;
            const offsetLeft = (this.shakaVideoContainerWidth - this.thumbnailBoxWidth) * mouseEventX / seekbarWidth;
            const offsetLeftTouchscreenLimit = Math.min(Math.max(0, offsetLeft), this.shakaVideoContainerWidth - this.thumbnailBoxWidth);
            this.thumbnailContainerElement.style.left = offsetLeftTouchscreenLimit + "px";
        })
        this.seekbar.addEventListener('pointerleave', (event) => { this.thumbnailContainerElement.style.display = "none" })
    }

    /**
     * Build the thumbnail box containing a thumbnail media element for canvas and a time element for timestamps
     * @private
     */
    buildThumbnailBox_() {
        this.seekbar = this.shakaContainer.querySelector(".shaka-player-container .shaka-seek-bar-container .shaka-seek-bar");
        this.thumbnailContainerElement = document.createElement('div');
        this.thumbnailContainerElement.className = 'thumbnail-box';
        this.thumbnailContainerElement.style.display = "none";
        this.thumbnailCanvasElement = document.createElement('div');
        this.thumbnailCanvasElement.className = 'thumbnail-media';
        this.timestampTextElement = document.createElement('div');
        this.timestampTextElement.className = 'thumbnail-time';
        this.thumbnailContainerElement.append(this.timestampTextElement, this.thumbnailCanvasElement);
        this.shakaContainer.querySelector('.shaka-scrim-container').append(this.thumbnailContainerElement);
    }

    /**
     * Compute the width and the height of the thumbnail box relative to the width and height of the video player. Furthermore, compute the bottom of the thumbnail box.
     * @private
     */
    computeThumbnailBoxStyle_() {
        this.shakaVideoContainer = this.shakaContainer.querySelector('.shaka-player-video');
        const html5VideoHeight = this.shakaVideoContainer.videoHeight;
        const html5VideoWidth = this.shakaVideoContainer.videoWidth;
        const videoAspectRatio = html5VideoHeight / html5VideoWidth;
        this.shakaVideoContainerWidth = this.shakaVideoContainer.getBoundingClientRect().width;
        this.thumbnailBoxWidth = 0.30 * this.shakaVideoContainerWidth > 250 ? 250 : 200;
        this.thumbnailBoxHeight = this.thumbnailBoxWidth * videoAspectRatio;
        this.thumbnailBoxBottom = this.shakaVideoContainer.getBoundingClientRect().bottom - this.seekbar.getBoundingClientRect().top + 4;
    }

    /**
     * Set the width, height and bottom of the thumbnail box
     * @private
     */
    setThumbnailBoxStyle_() {
        this.thumbnailContainerElement.style.width = this.thumbnailBoxWidth + "px";
        this.thumbnailContainerElement.style.height = this.thumbnailBoxHeight + "px";
        this.thumbnailContainerElement.style.bottom = this.thumbnailBoxBottom + "px";
    }
}